import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable, map, of } from 'rxjs'

import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

import { AiDocumentsTransformService } from '../../agents/documents/services/ai-documents-transform.service'
import { FileExtension, FileMimeType, FileUploadConfig } from '../../types/ai.types'

@Injectable({
  providedIn: 'root',
})
export class AiInitApi extends ApiHttpService {
  constructor() {
    const baseUrl = inject<string>('BASE_URL' as any)
    const httpClient = inject(HttpClient)

    super(baseUrl, httpClient)
  }

  init(): Observable<FileUploadConfig> {
    return of({
      imageUpload: {
        fileType: [FileMimeType.PNG, FileMimeType.JPEG, FileMimeType.JPG],
        maxFileSize: 3 * 1024 * 1024,
        maxFileNumber: 1,
      },
      bpmnUpload: {
        fileType: [FileMimeType.BPMN, FileExtension.BPMN],
        maxFileSize: 3 * 1024 * 1024,
        maxFileNumber: 1,
      },
      documentUpload: {
        fileType: [FileMimeType.PDF],
        maxFileSize: 15 * 1024 * 1024,
        maxFileNumber: 1,
      },
    }).pipe(map(AiDocumentsTransformService.configResponseTransform))
  }
}
